export default __webpack_public_path__ + "static/media/ep4-ceiling-bg.f480786a.jpg";